export const questions: Array<[string, string]> = [
  [
    'Who is this for?',
    'Solar technicians, entry-level PV professionals, electricians transitioning to solar, renewable energy learners.',
  ],
  [
    'What professional level?',
    'From installers to technicians to career-advancing professionals. Content scales from fundamentals through advanced applications.',
  ],
  ['International?', 'Yes. Universal PV technology principles with guidance for regional codes and standards.'],
  ['Editable?', 'Yes. Professional-grade PDFs for reference and study.'],
  ['Currency?', 'USD. Auto-converts to your local currency.'],
  [
    'What makes it different?',
    'Comprehensive technical depth: 6 integrated volumes, calculation exercises, troubleshooting frameworks, technical terminology, real-world case studies. For serious professional development.',
  ],
  ['Not satisfied?', '7-day refund, 100% money back.'],
];
